import { render } from "./ProvvigioniList.vue?vue&type=template&id=5771d6ea&ts=true"
import script from "./ProvvigioniList.vue?vue&type=script&lang=ts"
export * from "./ProvvigioniList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__